import React, { createContext, ReactNode, useCallback, useContext, useEffect, useRef, useState } from "react";
import CustomDialog from "../CustomViews/Elements/CustomDialog";
import { CustomDialogInterface } from "../Models/Common/CustomViewsInterfaces";
import styled from 'styled-components';

type DialogManagerProps = {
    setDialogContent: (option: CustomDialogInterface) => void;
    setOpenGlobalDialog: (isOpen: boolean) => void;
}
export const DialogManagerContext = createContext<DialogManagerProps>({
    setDialogContent: () => { },
    setOpenGlobalDialog: () => { },
})
export const useGlobalDialog = () => useContext(DialogManagerContext)

type IDialogManager = {
    subtitle?: React.ReactNode | string,
    setDialogInfo: React.Dispatch<React.SetStateAction<any>>,
} & CustomDialogInterface;

const ModalContainer = styled.div <{ $darkMode?: boolean; }>`
   .dialogManagerContainer {
        text-align: left;

        .MuiDialog-container.MuiDialog-scrollPaper {
            width: max-content;
            max-width: unset;
            place-self: center;

            .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.react-draggable {
                width: max-content;
                max-width: unset;

                .MuiDialogActions-root.MuiDialogActions-spacing {
                    padding: 10px 25px 25px 25px;
                }
            }
        }
   }

    .backupConfigModal  {
        .MuiDialog-container.MuiDialog-scrollPaper {
            .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.react-draggable {
                width: 70% !important;
            }
        }
    }

    .dbCloneModal  {
        .MuiDialog-container.MuiDialog-scrollPaper {
            .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.react-draggable {
                width: 40% !important;
            }
        }
    }
`;

function DialogContainer(props: IDialogManager) {
    const { children, openDialog, setOpenDialog, dialogClassName, title, subtitle, onCloseDialog, isDeleteConfirmation, setDialogInfo, clearDialog, disablePortal, actionButtons } = props;

    return (<ModalContainer>
        <CustomDialog {...{
            title: title,
            subtitle: subtitle ?? "",
            openDialog: openDialog,
            setOpenDialog: setOpenDialog,
            // onClickSave: onClickSave,
            clearDialog: clearDialog,
            onCloseDialog: (e: any) => {
                if (setOpenDialog)
                    setOpenDialog(false)
                setDialogInfo((prev: any) => ({ ...prev, children: null, isDeleteConfirmation: false }))
                onCloseDialog(e);
            },
            dialogClassName: "dialogManagerContainer " + (dialogClassName ?? ""),
            isDeleteConfirmation: isDeleteConfirmation,
            disablePortal: true,
            actionButtons: actionButtons,
        }}>
            {children}
        </CustomDialog>
    </ModalContainer>);
}

export default function DialogManager({ children }: { children: React.ReactNode }) {
    const [dialogInfo, setDialogInfo] = useState<CustomDialogInterface>({
        title: '',
        // onClickSave: () => { },
        openDialog: false,
        setOpenDialog: () => { },
        onCloseDialog: () => { },
        isDeleteConfirmation: false,
    });
    const [open, setOpen] = useState(false);
    const setDialogContent = (option: CustomDialogInterface) => {
        const newDialog: CustomDialogInterface = { ...option, openDialog: true, };
        // setDialogInfo(prev => ({ ...prev, ...option, openDialog: true }));
        setDialogInfo(newDialog)
        setOpen(true)
    };
    // const clearDialog = () => {
    //     setDialogInfo({
    //         title: '',
    //         onClickSave: () => { },
    //         openDialog: false,
    //         setOpenDialog: () => { },
    //         onCloseDialog: () => { },
    //         isDeleteConfirmation: false,
    //     })
    // }
    const setOpenGlobalDialog = (isOpen: boolean) => {
        // if (!isOpen)
        //     setDialogInfo(prev => ({ ...prev, children: null, isDeleteConfirmation: false }))
        setOpen(isOpen)
    };

    return (
        <DialogManagerContext.Provider value={{ setDialogContent, setOpenGlobalDialog }}>
            {open &&
                <DialogContainer
                    {...dialogInfo}
                    key='appGlobalDialog'
                    openDialog={open}
                    // clearDialog={clearDialog}
                    setOpenDialog={(isOpen: boolean) => setOpen(isOpen)}
                    setDialogInfo={setDialogInfo} />
            }
            {children}
        </DialogManagerContext.Provider>
    );
}
